import { render, staticRenderFns } from "./JobHistoryCustomFields.vue?vue&type=template&id=104e086c&"
import script from "./JobHistoryCustomFields.vue?vue&type=script&lang=ts&"
export * from "./JobHistoryCustomFields.vue?vue&type=script&lang=ts&"
import style0 from "./JobHistoryCustomFields.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports